import { useContext } from "react";
import { Store } from "../../../shared/types";
import { StoreContext } from "../../context/store.context";

export function useStore(): Store {
  const store = useContext(StoreContext);
  return store;
}
